// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2GcyL","savePackageButton":"ClientWallet_savePackageButton__w-DXD"};